import React from 'react'

class AutoPilot extends React.Component {
  render() {
    return (
      <div class="be-ix-link-block"></div>
    )
  }
}
export default AutoPilot